import { Card, LinkButton, Text } from '@ocula/ui';
import { ReactComponent as RegionIcon } from '@ui/assets/icons/region.svg';
import { ReactComponent as TitleIcon } from '@ui/assets/icons/title-domain.svg';
import { iconSmall } from '@ui/styles';
import { useEffect } from 'react';

import { auth0LikeButton } from './auth0LikeButton.css';
import styles from './landingPage.css';

const messages = {
  regions: {
    eu: 'UK/Europe',
    us: 'North America',
  },
  cardTitle: 'Continue previous session',
  cardDescription:
    'Your organisation and region details have been automatically selected for you based on your previous session, if this looks incorrect then please proceed to enter the correct details.',
  idLabel: 'ID:',
  regionLabel: 'Region:',
  continueButton: 'Continue',
  switchRegionButton: "This doesn't look right",
};

const trackingProps = {
  'location journey': 'Authentication',
  'location page': 'Continue Session',
  actor: 'User',
};

type Props = {
  goToSelectRegion?: () => void;
};

const Location = (region: string | null) => {
  switch (region) {
    case 'eu':
      return messages.regions.eu;
    case 'us':
      return messages.regions.us;
    default:
      return null;
  }
};

const ContinueSessionComponent = ({ goToSelectRegion }: Props) => {
  const storedDisplayName = localStorage.getItem('auth0DisplayName');
  const storedOrgName = localStorage.getItem('auth0Name');
  const storedRegion = localStorage.getItem('auth0Region');
  useEffect(() => {
    localStorage.removeItem('orgIdStatus');
  }, []);
  return (
    <div className={styles.componentContainer}>
      <div className={styles.cardHeader}>
        <Card.Title>{messages.cardTitle}</Card.Title>
        <Text variant="meta">{messages.cardDescription}</Text>
      </div>

      <div className={styles.cardContent}>
        <div className={styles.sessionContainer}>
          <Text variant="bold">{storedDisplayName}</Text>
          <p className={styles.sessionDetails}>
            <span className={styles.sessionItem}>
              <TitleIcon className={iconSmall} aria-hidden />
              <Text variant="meta" tag="span">
                <Text variant="bold">{messages.idLabel}</Text> {storedOrgName}
              </Text>
            </span>
            <span className={styles.sessionItem}>
              <RegionIcon className={iconSmall} aria-hidden />
              <Text variant="meta" tag="span">
                <Text variant="bold">{messages.regionLabel}</Text> {Location(storedRegion)}
              </Text>
            </span>
          </p>
        </div>
        <LinkButton
          to={`/${storedRegion}`}
          variant="primary"
          className={auth0LikeButton}
          onClick={() => localStorage.setItem('orgIdStatus', 'confirmedByUser')}
          trackingProps={{
            ...trackingProps,
            'location component name': 'Continue Session Button',
          }}
        >
          {messages.continueButton}
        </LinkButton>
        <LinkButton
          variant="secondary"
          className={auth0LikeButton}
          onClick={goToSelectRegion}
          trackingProps={{
            ...trackingProps,
            'location component name': 'Switch Region Button',
          }}
        >
          {messages.switchRegionButton}
        </LinkButton>
      </div>
    </div>
  );
};

export default ContinueSessionComponent;
